<rt-dropdown *ngIf="isCandidate()">
  <rt-dropdown-header>
    {{ 'rtu.common.candidate' | translate }}
  </rt-dropdown-header>
  <rt-dropdown-item class="info-item" layout layout-vertical>
    <div class="info-wrap" layout layout-align-items-center>
      <rt-avatar
        [type]="'image'"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="tag.candidate!.photoThumbUrl"
      >
      </rt-avatar>
      <div class="text-wrap" layout layout-vertical>
        <rt-heading>
          {{ tag.candidate!.name }}
        </rt-heading>
        <div
          *ngIf="tag.candidate!.placements && tag.candidate!.placements.length"
          class="text"
          layout
        >
          <span *ngIf="tag.candidate!.placements[0].offer">
            {{ tag.candidate!.placements[0].offer.title }}
          </span>
        </div>
      </div>
    </div>
    <rt-heading variant="subheading small" class="title-wrap">
      {{ 'rtu.mailbox.send_mail_to' | translate }}
    </rt-heading>
  </rt-dropdown-item>
  <ng-container *ngIf="tag.candidate!.emails.length">
    <rt-dropdown-item
      *ngFor="let email of tag.candidate!.emails; trackBy: trackByEmail"
      [hasSymbol]="false"
      (click)="select(email)"
      variant="padding-small-x"
    >
      <div class="item-content">
        <div class="item-content-email">
          <rt-truncate>{{ email }}</rt-truncate>
        </div>
        <rt-icon *ngIf="isEmailActive(email)" name="check" size="medium" text-primary></rt-icon>
      </div>
    </rt-dropdown-item>
  </ng-container>
  <ng-container *ngIf="!tag.candidate!.emails.length && tag.email">
    <rt-dropdown-item variant="padding-small-x">
      <div class="item-content">
        <div class="item-content-email">
          <rt-truncate>{{ tag.email }}</rt-truncate>
        </div>
        <rt-icon name="check" size="medium" text-primary> </rt-icon>
      </div>
    </rt-dropdown-item>
  </ng-container>
  <rt-dropdown-item variant="padding-small-x footer" (click)="showCandidate()">
    {{ 'rtu.mailbox.go_to_profile' | translate }}
  </rt-dropdown-item>
</rt-dropdown>

<rt-dropdown *ngIf="isAdmin()">
  <rt-dropdown-header>
    {{ 'rtu.common.team_member' | translate }}
  </rt-dropdown-header>
  <rt-dropdown-item class="info-item" layout layout-vertical>
    <div class="info-wrap" layout layout-align-items-center>
      <rt-avatar
        [type]="'image'"
        [size]="'base'"
        [shape]="'oval'"
        [imageSrc]="tag.admin!.photoThumbUrl"
      >
      </rt-avatar>
      <div class="text-wrap" layout layout-vertical>
        <rt-heading>{{ tag.name }}</rt-heading>
        <div class="text" layout>
          <span>{{ tag.email }}</span>
        </div>
      </div>
    </div>
  </rt-dropdown-item>
  <rt-dropdown-item href="#/settings/memberships" variant="padding-small-x footer">
    {{ 'rtu.mailbox.go_to_team_member' | translate }}
  </rt-dropdown-item>
</rt-dropdown>

<rt-dropdown *ngIf="!isCandidate() && !isAdmin()">
  <rt-dropdown-item class="info-item" layout layout-vertical>
    <div class="info-wrap" layout layout-align-items-center>
      <div class="text-wrap" layout layout-vertical>
        <rt-heading>{{ tag.name }}</rt-heading>
        <div class="text" layout>
          <span>{{ tag.email }}</span>
        </div>
      </div>
    </div>
  </rt-dropdown-item>
</rt-dropdown>
